module.exports = __webpack_public_path__ + "img/zch-logo.be45fec2.png";